import "backboneAjaxQAdapter";

import GenericView from 'views/generic.view.ts';

import Handlebars from 'handlebars';
import Template from 'text-loader!../../../../templates/analytics/venues/users/user_statistics.row.template.html';
import QueueHorizontalRowTemplate from 'text-loader!../../../../templates/analytics/venues/users/queue_horizontal.row.template.html';

import colors from '../../../../../libs/assets/colors.js';
import i18n  from "l10n";

export default GenericView.extend({
    tagName: 'tr',
    className: 'row',
	template: Handlebars.compile(Template),
	queueHorizontalRowTemplate: Handlebars.compile(QueueHorizontalRowTemplate),
	data: null,
    initialize: function (options) {
        var self = this;

        this.data = options ? options.data : null;
	},
	superRender: Backbone.View.prototype.render,
	render: function () {
		var self = this;
		this.superRender();

        var templateParams = $.extend({}, this.data, {"lang": i18n.lng()});
        var templateData = this.data.type == "QueueHorizontalRow" ? this.queueHorizontalRowTemplate(templateParams) : this.template(templateParams);

		this.$el.html( templateData );


        return this;
	},
	events:{

    }

});


